import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  page: {
    width: "100%",
  },
  headerBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
    padding: "18px 22px",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  headerIconBadge: {
    width: 36,
    height: 36,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#e9f5ec",
    color: theme.palette.primary.main,
    "& .MuiSvgIcon-root": {
      fontSize: 20,
    },
  },
  headerTitle: {
    fontWeight: 700,
    color: "#10212a",
    fontSize: 20,
  },
  headerCount: {
    color: "#7a8a92",
    fontSize: 14,
    marginLeft: 6,
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
  },
  primaryButton: {
    backgroundColor: theme.palette.custom.main,
    "&:hover": {
      backgroundColor: "#ec7905",
    },
  },
  filterBar: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    padding: "16px 22px",
    borderTop: "1px solid #EEF0F4",
    borderBottom: "1px solid #EEF0F4",
  },
  searchField: {
    flex: "1 1 260px",
    maxWidth: 360,
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#fff",
    },
  },
  tableContainer: {
    "& .MuiTableCell-root": {
      borderBottom: "1px solid #EEF0F4",
      padding: "14px 16px",
    },
  },
  tableHeadCell: {
    whiteSpace: "nowrap",
  },
  bodyRow: {
    cursor: "default",
  },
  nameCell: {
    maxWidth: 220,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  nameText: {
    color: "#10212a",
    fontWeight: 600,
  },
  keyText: {
    color: "#5b6870",
    fontSize: 13,
    maxWidth: 260,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  chip: {
    backgroundColor: "#F2F4F7",
    color: "#344054",
    fontWeight: 600,
    fontSize: 12,
    height: 22,
  },
  statusChip: {
    fontWeight: 600,
    fontSize: 12,
    height: 24,
  },
  statusActive: {
    backgroundColor: "#e9f5ec",
    color: theme.palette.primary.main,
  },
  statusInactive: {
    backgroundColor: "#FEF3F2",
    color: "#B42318",
  },
  cellMuted: {
    color: "#98A2B3",
  },
  emptyState: {
    padding: "48px 16px",
    textAlign: "center",
    color: "#5b6870",
  },
  footerBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    padding: "14px 22px",
  },
  footerText: {
    color: "#5b6870",
    fontSize: 13,
  },
  paginationGroup: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  paginationPage: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 8,
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    fontWeight: 700,
    minWidth: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
  },
  dialogTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    fontWeight: 700,
  },
  closeIcon: {
    color: "#98A2B3",
  },
  fieldWrapper: {
    paddingBlock: 8,
  },
  fileButton: {
    justifyContent: "flex-start",
    textTransform: "none",
  },
  fileNameText: {
    marginTop: 6,
    color: "#5b6870",
    fontSize: 13,
  },
  dialogActions: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    padding: "8px 16px",
  },
}));

export default useStyles;
